export default __webpack_public_path__ + "static/media/picto_Parsing_white_tech.2f5648d7.svg";